require('CWCookie')
.define('ClosedLotsFilter',function (imports) {
  var CWCookie = imports.CWCookie;

  function ClosedLotsFilter(auction_id) {
    this.checkbox = $('input#show_closed_lots');
    this.checkbox_div = this.checkbox.parents('.show_closed_lots');
    this.auction_id = auction_id;
    this.listeners = [] ;
    this.init();
  }

  ClosedLotsFilter.prototype.show = function (visible, initial_value) {
    if (!visible) {
      initial_value = true ; //show closed lots if checkbox is not visible
    }
    else if (initial_value == null) {
      initial_value = CWCookie.get_cookie("show_closed_lots");
    }
    this.set_value(initial_value);
    this.checkbox_div.css('display', visible ? 'block' : 'none');
  }

  ClosedLotsFilter.prototype.set_value = function (show_closed_lots, from_gui) {
    if (show_closed_lots) {
      CWCookie.set_cookie('show_closed_lots', true);//, {domain:cw_domain, path:'/'});
      CWCookie.set_cookie('show_closed_lots_auction_id', this.auction_id);
      this.emit_event('change',true);
    } else {
      CWCookie.remove_cookie('show_closed_lots');//, {domain:cw_domain, path:'/'});
      this.emit_event('change',false);
    }
    if (from_gui == null) {
      this.checkbox.attr('checked', CWCookie.get_cookie('show_closed_lots'));
    }
  }

  ClosedLotsFilter.prototype.show_closed_lots = function() {
    return CWCookie.get_cookie("show_closed_lots");
  }

  ClosedLotsFilter.prototype.on_change = function (listener) {
    this.listeners.push(listener);
  }

  ClosedLotsFilter.prototype.emit_event = function (event_name, event) {
    if (event_name === 'change') {
      for (var i=0; i < this.listeners.length ; i++) {
        this.listeners[i](event);
      }
    }
  }

  ClosedLotsFilter.prototype.init = function () {
    if (typeof(this.auction_id)!='undefined' && (CWCookie.get_cookie("show_closed_lots_auction_id") != this.auction_id)) {
      CWCookie.remove_cookie('show_closed_lots');
      CWCookie.set_cookie("show_closed_lots_auction_id", this.auction_id);
    }
    var self = this;
    this.checkbox.on('click', function() {
      self.set_value($(this).is(':checked'), true);
    });
  }


  return ClosedLotsFilter;

})